const initialState: State = {
    runes: [],
    spreads: [],
    selected_spread: null
}

export default initialState